var _ = require('underscore');
var TorsoFormModel = require('backbone-torso/modules/FormModel');
var workflowNodes = require('./../utils/workflowNodes');

/**
 * This is the form model for EregAppointmentSelectWorkflowFormView
 * @class EregAppointmentSelectWorkflowFormModel
 * @constructor
 * @extends Torso.FormModel
 */
module.exports = TorsoFormModel.extend({

  /**
   * Get the status of the workflow nodes. Workflow nodes are defined in workflowNodes.js.
   * @method getAllWorkflowStepsStatus
   * @return {Object} a map from workflow nodes to status, true if it's enabled on client and appointment levels and it's checked e.g. {'demographics': true, 'insurance': false, ...}
   */
  getAllWorkflowStepsStatus: function() {
    var self = this,
        workflowSteps = {};
    _.each(_.keys(workflowNodes), function(workflowNode) {
      workflowSteps[workflowNode + 'Enabled'] = self.get(workflowNode + 'EnabledOnClient')
      && self.get(workflowNode + 'EnabledOnAppointment')
      && self.get(workflowNode + 'Checked');
    });
    return workflowSteps;
  },

  /**
   * Get disabled workflow nodes. Workflow nodes are defined in workflowNodes.js.
   * @method getDisabledWorkflowSteps
   * @return {Object} a map from disabled workflow nodes to true e.g. {'demographics': false, 'insurance': false, ...}
   */
  getDisabledWorkflowSteps: function() {
    var disabledWorkflowSteps = {},
        workflowSteps = this.getAllWorkflowStepsStatus();
    _.each(_.keys(workflowNodes), function(workflowNode) {
      if (workflowSteps[workflowNode + 'Enabled'] === false) {
        disabledWorkflowSteps[workflowNode] = true;
      }
    });
    return disabledWorkflowSteps;
  }
});
